import React from 'react'
import Navibar from './Navibar'
import styles from './styles/Home.module.css'
import ShowcaseFooter from './Footer'
import NewsItem from './NewsItem'

export default function NewsPage(props) {
  const items = props.items
  const newsItems = []
  items.forEach((item, index) => {
    newsItems.push(
      <NewsItem
        key={index}
        item={item}
        onUpdate={() => {
          props.onUpdateClick(item.id)
        }}
        onDelete={() => {
          props.onDeleteClick(item.id)
        }}
      />
    )
  })

  return (
    <div style={{ overflowX: 'hidden' }}>
      <Navibar {...props} />
      <main className={styles.main}>{newsItems}</main>
      <ShowcaseFooter />
    </div>
  )
}
